export const defaultConfig = {
    world: {
        gravitation: {
            x: 0,
            y: -9.81,
            z: 0
        }
    }
};
//# sourceMappingURL=index.js.map